import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { HabilidadeHabilidadeCargo } from "../../../../domain/models/habilidade_habilidade_cargo";

import CascateList from "../../../../../../common/components/cascate_list";

/**
 * Header
 */

type Props = {
  selectedHabilidade: HabilidadeHabilidadeCargo | undefined,
  habilidades: HabilidadeHabilidadeCargo[],
  onSelectHabilidade: (habilidade: HabilidadeHabilidadeCargo | null) => void,
};

export const Header = ({
  selectedHabilidade,
  habilidades,
  onSelectHabilidade,
}: Props) => {
  return (
    <>
      <CascateList
        title="Selecione o habilidade"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full">
            <DefaultAutocomplete
              label='Habilidade'
              options={habilidades}
              getOptionLabel={x => x.nome}
              getOptionKey={x => x.idHabilidade}
              value={selectedHabilidade}
              onChange={onSelectHabilidade} />
          </div>
        </div>
      </CascateList>
    </>
  );
}